enum InviteEmailCategoryTypeEnum {
  Ticketed = 0,
  NonTicketed = 1,
  Others = 2
}

export default Object.freeze(InviteEmailCategoryTypeEnum);
